import React, { useEffect, useContext, useState } from "react";
import { observer } from "mobx-react";
import { StoreContext } from "../StoreContext";
import { CircularProgress } from "@mui/material";
import { ProcessState } from "../stores/models";
import styled from "@emotion/styled";
const Styled_LoadingProgress = styled("div")(({ theme }) => ({
    height: "50%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));
const Locationbar = observer((props) => {
    const context = useContext(StoreContext);
    const [init, setInit] = useState(false);
    const applyLocation = (location, history) => {
        let pathnameRefined = location.pathname;
        if (pathnameRefined.startsWith("/")) {
            pathnameRefined = pathnameRefined.replace("/", "");
        }
        if (pathnameRefined == "") {
            context.rootStore.jobPanelStore.setSelectedEntry(null);
        }
        else {
            let infos = pathnameRefined.split("_");
            let panel = context.rootStore.jobPanelStore.getJobPanel(parseInt(infos[0]));
            if (panel) {
                let entries = Object.values(panel.jobPanelEntries).filter((entry) => entry.entry && entry.entry.id == parseInt(infos[1]));
                if (entries.length > 0) {
                    context.rootStore.jobPanelStore.setSelectedEntry(entries[0].entry, panel.id);
                    return;
                }
            }
            context.rootStore.jobPanelStore.setSelectedEntry(null);
        }
    };
    useEffect(() => {
        context.rootStore.jobPanelStore.loadJobPanels();
    }, []);
    useEffect(() => {
        if (!init && context.rootStore.jobPanelStore.loadState != ProcessState.LOADING) {
            const history = context.rootStore.hashHistory;
            if (history) {
                let unsubscribeHist = history.listen(({ location, action }) => {
                    applyLocation(location, history);
                });
                //apply current location
                applyLocation(history.location, history);
                setInit(true);
                return () => {
                    unsubscribeHist();
                };
            }
            else {
                setInit(true);
            }
        }
    }, [context.rootStore.jobPanelStore.loadState]);
    return init ? (React.createElement(React.Fragment, null, props.children)) : (React.createElement(Styled_LoadingProgress, null,
        React.createElement(CircularProgress, null)));
});
export default Locationbar;
